// Иконки нового меню и главной. Регистрируются один раз при импорте модуля.
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAddressBook, faAnglesLeft, faAnglesRight, faArrowRight, faBell, faBookOpen, faBroom, faBuilding, faBullhorn,
  faCalculator, faChartArea, faChartColumn, faChartLine, faChartPie, faChevronDown, faCircleCheck, faClone,
  faCoins, faFileCircleCheck, faFileInvoice, faFileInvoiceDollar, faFileLines, faFolderOpen, faGaugeHigh, faGear,
  faHandshake, faHourglassHalf, faHouse, faIdCard, faListCheck, faMagnifyingGlass, faMagnifyingGlassDollar,
  faRobot, faRoute, faScaleBalanced, faScaleUnbalanced, faShieldHalved, faSliders, faStar, faTable, faTags,
  faToggleOn, faTrailer, faTrophy, faTruck, faTruckFront, faUser, faUserCheck, faUserShield, faUsers, faWallet,
  faXmark, faBolt, faCircleQuestion, faBars,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faAddressBook, faAnglesLeft, faAnglesRight, faArrowRight, faBell, faBookOpen, faBroom, faBuilding, faBullhorn,
  faCalculator, faChartArea, faChartColumn, faChartLine, faChartPie, faChevronDown, faCircleCheck, faClone,
  faCoins, faFileCircleCheck, faFileInvoice, faFileInvoiceDollar, faFileLines, faFolderOpen, faGaugeHigh, faGear,
  faHandshake, faHourglassHalf, faHouse, faIdCard, faListCheck, faMagnifyingGlass, faMagnifyingGlassDollar,
  faRobot, faRoute, faScaleBalanced, faScaleUnbalanced, faShieldHalved, faSliders, faStar, faTable, faTags,
  faToggleOn, faTrailer, faTrophy, faTruck, faTruckFront, faUser, faUserCheck, faUserShield, faUsers, faWallet,
  faXmark, faBolt, faCircleQuestion, faBars,
)
